<style lang="scss" scoped>
.settings {
    @include container();
    &__section {
        padding-bottom: 70px;
        border-bottom: 1px solid #eee;
        margin-bottom: 30px;
        &:last-child {
            margin-bottom: 0;
            border-bottom: 0;
        }
    }
    &__year {
        margin-left: 20px;
    }
    &__row {
        @include grid();
    }
    &__left {
        @include grid-col(4);
        padding-right: 40px;
    }
    &__right {
        @include grid-col(8);
    }
    &__pad-bottom {
        margin-bottom: 30px;
    }
    &__pad-right {
        padding: 20px;
    }
    &__border-bottom {
        border-bottom: 1px solid #eee;
    }
    & ::v-deep .el-cascader {
        width: 100%;
    }
    & ::v-deep .el-select {
        width: 100%;
    }
    .warning a {
        color: #eb4335 !important;
        font-weight: bold;
    }
    .preview {
        margin: 0;
    }

    .d-block {
        display:block;
        line-height:1;
        
    }
    .d-block ~ span, .warning-text {
            margin-bottom:50px;
            font-size:13px;
            color:red
        }

    &__supplementary-text {
        font-size: 12px;
        line-height: 1.3;
        padding-bottom: 10px;
    }

    .dashboardTiles {
        display:flex;
        flex-wrap: wrap;
        & div {
            & .dashboardTiles-item {
                min-width: 160px;
                margin: 10px 10px 0 0;
            }
        }
    }

}

</style>
<template lang="pug">
.settings
    .main-panel
        loading(v-if="!form && $apollo.loading")
        template(v-if="form")
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2 School
                    .settings__right 
                        el-card.box-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span {{ school.name }}
                            el-form(label-position="top", v-if="school.Organisation")
                                template
                                    div.settings__pad-bottom
                                        div.settings__pad-bottom
                                            el-switch(v-model="form.org_sync_enabled")
                                            span.settings__pad-right Enable organisation-level sync
                                            <br>
                                            span.warning-text(v-if="!form.org_sync_enabled") Now select a different Apple School Manager tenant utilising the SFTP settings below
                            el-form(label-position="top", v-if="isOrgSyncDisabled()")
                                custom-field-format(
                                            v-model="form.location_id_format",
                                            fieldLabel="Location ID format",
                                            :fieldNames="fieldNames.location",
                                            settingKey="location_id_format"
                                )
                                custom-field-format(
                                    v-model="form.location_name_format",
                                    fieldLabel="Location name format",
                                    :fieldNames="fieldNames.location",
                                    settingKey="location_name_format"
                                )
                            el-form(label-position="top", v-if="isOrgSyncDisabled()")
                                el-form-item(label="Phase of education")
                                    el-input(disabled, size="medium", v-model="school.phase_of_education")
                                el-form-item(label="Sync schedules")
                                    sync-schedules(v-model="form.sync_schedules", :persistedSchedules="form.sync_schedules", :autoSyncTime="form.auto_sync_time")
                            div.settings__pad-bottom
                                div.settings__pad-bottom
                                    el-switch(v-model="form.add_dummy_data")
                                    span.settings__pad-right Add mock data in empty CSVs
                                    <br><br>
                                    el-alert(type="warning" description="Enabling mock data will populate relevant CSVs with a mock class, teacher and student, as ASM requires at least one class for SFTP to upload successfully. This will allow users to provision Managed Apple IDs without having to supply actual class data")
                            el-form(label-position="top")
                                el-form-item(label="Admin email")
                                    el-input(size="medium", v-model="form.admin_email")
            .main-panel__padding.settings__section(v-if="isOrgSyncDisabled()")
                .settings__row
                    .settings__left
                        h2 Domains
                    .settings__right
                        el-card.box-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Students
                            el-form(label-position="top")
                                el-form-item(label="Student domain")
                                    el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain", placeholder="Select")
                                        el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
                                    el-input(v-else, size="medium", v-model="form.domain", placeholder="Student domain name")
                                div(v-if="features.ou")
                                    el-form-item(:label="'Which ' + orgUnitLabel.name + ' do you want to use to create and manage students?'")
                                        organisation-selector(v-model="form.student_org_unit_id")
                                    student-ou-structure(v-if="features.ou_structure", v-model="form.student_org_unit_structure")
                        el-card.box-card
                            .clearfix(slot="header")
                                span Staff
                            el-form(label-position="top")
                                el-form-item(label="Staff domain")
                                    el-select(v-if="providerCode == 'gapps'", name="format", v-model="form.domain_employee", placeholder="Select")
                                        el-option(v-for="item in domains", :key="item.id", :label="item.id", :value="item.id")
                                    el-input(v-else, size="medium", v-model="form.domain_employee", placeholder="Staff domain name")
                                div(v-if="features.ou")
                                    el-form-item(:label="'Which ' + orgUnitLabel.name + ' do you want to use to create and manage staff?'")
                                        organisation-selector(v-model="form.employee_org_unit_id")
            .main-panel__padding.settings__section(v-if="updated")
                .settings__row
                    .settings__left
                        h2.mt-3 Rules
                        p Control which users are available from your {{ misLabel }} data. Create custom rules by filtering students by registration, house, and year groups.
                    .settings__right
                        student-rules.settings__pad-bottom(v-model="student_rule_object")
                        employee-rules(v-model="employee_rule_object")
            .main-panel__padding.settings__section
                .settings__row
                    .settings__left
                        h2.mt-3 Account management
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Account creation
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        el-form-item(v-if="isOrgSyncDisabled()")
                                            custom-field-format(
                                                v-model="form.student_id_field",
                                                fieldLabel="Student person ID",
                                                :fieldNames="{ ...fieldNames.personIdBase, ...fieldNames.studentId }",
                                                settingKey="student_id_field")
                                            span.warning-text(v-if="form.student_id_field !== 'edusync_id'") Only use this if the ID is unique across all your users regardless of type to avoid missing users due to conflict
                                        el-form-item(v-if="isOrgSyncDisabled()")
                                            custom-field-format(
                                                    v-model="form.employee_id_field",
                                                    fieldLabel="Employee person ID",
                                                    :fieldNames="{ ...fieldNames.personIdBase, ...fieldNames.employeeId }",
                                                    settingKey="employee_id_field")
                                            span.warning-text(v-if="form.employee_id_field !== 'edusync_id'") Only use this if the ID is unique across all your users regardless of type to avoid missing users due to conflict
                                        el-form-item(label="Student email account creation")
                                            el-select(v-model="form.email_account_creation_option_student")
                                                el-option(v-for="(item,i) in userEmailAccountCreationOptions.student" :key="i" :label="item.label" :value="item.value" )
                                        el-form-item(label="Staff email account creation")
                                            el-select(v-model="form.email_account_creation_option_employee")
                                                el-option(v-for="(item,i) in userEmailAccountCreationOptions.employee" :key="i" :label="item.label" :value="item.value" )
                                        el-form-item(label="Student SIS username")
                                            el-select(v-model="form.sis_username_student")
                                                el-option(v-for="(item,i) in SISUsernameOptions" :key="i" :label="item.label" :value="item.value" )
                                        el-form-item(label="Staff SIS username")
                                            el-select(v-model="form.sis_username_employee")
                                                el-option(v-for="(item,i) in SISUsernameOptions" :key="i" :label="item.label" :value="item.value" )
                                        el-form-item(label="Student password policy")
                                            el-select(v-model="form.password_policy_student")
                                                el-option(v-for="(item,i) in passwordPolicies" :key="i" :label="item.label" :value="item.value" )
                                        el-form-item(label="Staff password policy")
                                            el-select(v-model="form.password_policy_employee")
                                                el-option(v-for="(item,i) in passwordPolicies" :key="i" :label="item.label" :value="item.value" )
                        el-card.settings__pad-bottom(v-if="isOrgSyncDisabled()")
                            .clearfix(slot="header")
                                span Account deactivation
                            el-form(label-position="top")
                                el-form-item(label="Deactivate student accounts")
                                    el-radio(v-model="form.deletion_mode_student", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
                                    el-radio(v-model="form.deletion_mode_student", label="self", border="", size="medium") Manually within {{ providerName }} School Manager
                                template(v-if="form.deletion_mode_student == 'auto'")
                                    el-form-item(label="Deactivate student accounts after")
                                        el-input-number(:min="0", :max="365", size="medium", v-model="form.suspend_delay_student", e2e="suspend_days")
                                        |
                                        | {{ form.suspend_delay_student == 1 ? 'day' : 'days' }}
                                el-form-item(label="Deactivate staff accounts")
                                    el-radio(v-model="form.deletion_mode_employee", label="auto", border="", size="medium") Automatically with Edusync {{ providerName }}
                                    el-radio(v-model="form.deletion_mode_employee", label="self", border="", size="medium") Manually within {{ providerName }} School Manager
                                template(v-if="form.deletion_mode_employee == 'auto'")
                                    el-form-item(label="Deactivate staff accounts after")
                                        el-input-number(:min="0", :max="365", size="medium", v-model="form.suspend_delay_employee", e2e="suspend_days")
                                        |
                                        | {{ form.suspend_delay_employee == 1 ? 'day' : 'days' }}
            
            .main-panel__padding.settings__section(v-if="isOrgSyncDisabled()")
                .settings__row
                    .settings__left
                        h2.mt-3 Emails
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span User emails
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        div.settings__pad-bottom
                                            el-radio(v-model="form.student_use_mis_email", :label="false", border="") Generate student emails
                                            el-radio(v-model="form.student_use_mis_email", :label="true", border="") Use {{ misLabel }} student emails
                                        el-form-item.settings__pad-bottom(label="Student email format (naming convention)" v-if="!form.student_use_mis_email")
                                            el-select(name="format", v-model="form.email_format_student", placeholder="Select")
                                                el-option(v-for="item in email_formats.student", :key="item.value", :label="item.label", :value="item.value")
                                        el-form-item(label="Student email" v-else)
                                            el-select(v-model="form.email_field_student")
                                                el-option(v-for="(item,i) in userEmailOptions" :key="i" :label="item.label" :value="item.value")
                                    div.settings__pad-bottom
                                        div.settings__pad-bottom
                                            el-radio(v-model="form.employee_use_mis_email", :label="false", border="") Generate staff emails
                                            el-radio(v-model="form.employee_use_mis_email", :label="true", border="") Use {{ misLabel }} staff emails
                                        el-form-item(label="Staff email format (naming convention)" v-if="!form.employee_use_mis_email")
                                            el-select(name="format", v-model="form.email_format_employee", placeholder="Select")
                                                el-option(v-for="item in email_formats.employee", :key="item.value", :label="item.label", :value="item.value")
                                        el-form-item(label="Employee email" v-else)
                                            el-select(v-model="form.email_field_employee")
                                                el-option(v-for="(item,i) in userEmailOptions" :key="i" :label="item.label" :value="item.value")
            .main-panel__padding.settings__section(v-if="isOrgSyncDisabled()")
                .settings__row
                    .settings__left
                        h2.mt-3 Classes and Courses
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Classes
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        div.settings__pad-bottom
                                            el-switch(v-model="form.auto_sync_classes")
                                            span.settings__pad-right Automatically sync all new classes
                                        custom-field-format(
                                            v-model="form.class_id_format",
                                            fieldLabel="Class ID format",
                                            :fieldNames="fieldNames.class",
                                            settingKey="class_id_format"
                                        )
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Courses
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        custom-field-format(
                                            v-model="form.course_id_format",
                                            fieldLabel="Course ID format",
                                            :fieldNames="fieldNames.course",
                                            settingKey="course_id_format"
                                        )
                                        custom-field-format(
                                            v-model="form.course_name_format",
                                            fieldLabel="Course name format",
                                            :fieldNames="fieldNames.course",
                                            settingKey="course_name_format"
                                        )
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span Rosters
                            el-form(label-position="top")
                                template
                                    div.settings__pad-bottom
                                        custom-field-format(
                                            v-model="form.roster_id_format",
                                            fieldLabel="Roster ID format",
                                            :fieldNames="fieldNames.roster",
                                            settingKey="roster_id_format"
                                        )
            .main-panel__padding.settings__section(v-if="isOrgSyncDisabled()")
                .settings__row
                    .settings__left
                        h2.mt-3 Apple School Manager connection
                    .settings__right
                        el-card.settings__pad-bottom
                            .clearfix(slot="header")
                                span SFTP Access Details
                            el-form(label-position="top")
                                template
                                    el-form-item(label="Host")
                                        el-input(size="medium", v-model="form.sftp_host")
                                    el-form-item(label="Username")
                                        el-input(size="medium", v-model="form.sftp_username")
                                    el-form-item(label="Password")
                                        el-input(type="password", size="medium", v-model="form.sftp_password")
        slot(name="footer")
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import moment from "moment";
import StudentRules from "./../StudentRules";
import EmployeeRules from "./../EmployeeRules";
import CustomFieldFormat from './../CustomFieldFormat';
import SyncSchedules from './../SyncSchedules.vue';

export default {
    components: {
        StudentRules,
        EmployeeRules,
        CustomFieldFormat,
        SyncSchedules,
    },
    computed: {
        domain () {
            return this.form.domain_employee || this.form.domain
        },
        email_formats() {
            if (this.previewUser && this.form) {
                console.log(this.form.email_formats, 'what is this')
                const studentFormats = _.map(this.form.email_formats, formatString => this.calcFormatsWithLabels(formatString, this.form.domain));
                const employeeDomain = this.form.domain_employee || this.form.domain;
                const employeeFormats = _.map(this.form.email_formats, formatString => this.calcFormatsWithLabels(formatString, employeeDomain));
                const processed = { student: studentFormats, employee: employeeFormats };
        
                if (!_.some(studentFormats, { value: this.form.email_format_student })) {
                    processed.student.push(this.calcFormatsWithLabels(this.form.email_format_student, this.form.domain, " (Custom)"));
                }
        
                if (!_.some(employeeFormats, { value: this.form.email_format_employee })) {
                    processed.employee.push(this.calcFormatsWithLabels(this.form.email_format_employee, employeeDomain, " (Custom)"));
                }
        
                return processed;
            } else {
                return [];
            }
        },
    },

    apollo: {
        domains: {
            query: gql`
                {
                    Domains(verified: true) {
                        id
                        primary
                        verified
                    }
                }
            `,
            fetchPolicy: "cache-and-network",
            update: (r) => r.Domains,
        },
        previewUser: {
            query: gql`
                {
                    User {
                        first_name
                        last_name
                    }
                }
            `,
            fetchPolicy: "cache-and-network",
            update: (r) => r.User,
        },
        form: {
            query: gql`
                {
                    Settings {
                        id
                        student_active
                        email_format_employee
                        email_format_student
                        employee_active
                        domain
                        domain_employee
                        email_formats
                        student_provision_rules {
                            group
                            operator
                            value
                        }
                        sftp_host
                        sftp_port
                        sftp_username
                        sftp_password
                        student_use_mis_email
                        employee_use_mis_email
                        password_policy_student
                        password_policy_employee
                        auto_sync_time
                        student_id_field
                        employee_id_field
                        deletion_mode_student
                        suspend_delay_student
                        deletion_mode_employee
                        suspend_delay_employee
                        org_sync_enabled
                        auto_sync_classes
                        course_id_format
                        course_name_format
                        location_id_format
                        location_name_format
                        class_id_format
                        email_field_employee
                        email_field_student
                        email_account_creation_option_employee
                        email_account_creation_option_student
                        roster_id_format
                        add_dummy_data
                        sync_schedules {
                            enabled
                            time
                        }
                        sis_username_student
                        sis_username_employee
                        admin_email
                    }
                }
            `,
            fetchPolicy: "no-cache",
            update(r) {
                let settings = _.cloneDeep(r.Settings);
                if (_.isEmpty(this.originalSettingsValues)) {
                    this.originalSettingsValues = _.cloneDeep(r.Settings);
                }
                this.student_rule_object.rules = _.cloneDeep(settings.student_provision_rules);
                this.student_rule_object.active = _.cloneDeep(settings.student_active);
                delete settings.student_provision_rules;
                delete settings.student_provision_rule_match;
                delete settings.student_active;
                this.employee_rule_object.active = _.cloneDeep(settings.employee_active);
                delete settings.employee_active;
                
                settings.auto_sync_time = moment.utc(settings.auto_sync_time, "HH:mm").local().format("HH:mm");

                return settings;
            },
        },
        orgSettings: {
            query: gql`
                query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
                        id
                        sftp_host
                        sftp_username
                    }
                }
            `,
            variables() {
                return {
                    type: "organisation"
                }
            },
            fetchPolicy: "no-cache",
            update(r) {
                return _.cloneDeep(r.Settings);
            },
        },
        school: {
            query: gql`
                query School {
                        School {
                            id
                            name
                            phase_of_education
                            Organisation {
                                id
                            }
                        }
                    }
            `,
            update: (r) => r.School,
        },
    },
    created() {
        setTimeout(() => {
            this.updated = true;
        }, 2000);
    },  

    methods: {
        setEmailFormats() {
            let studentEmailFormat = this.student_format.join(' + ').toString();
            let employeeEmailFormat = this.employee_format.join(' + ').toString();

            if (studentEmailFormat === "" || employeeEmailFormat === "") {
                this.loading = false;
                this.$emit("Saving", this.loading);
                this.$message.error("Failed to update settings");
                return ;
            }

            if (!studentEmailFormat.split(' + ').includes('number')) {
                let split = studentEmailFormat.split(' + ');
                split.push('number')
                studentEmailFormat = split.join(' + ').toString()
            }

            if (!employeeEmailFormat.split(' + ').includes('number')) {
                let split = employeeEmailFormat.split(' + ');
                split.push('number')
                employeeEmailFormat = split.join(' + ').toString()
            }

            return { email_format_student: studentEmailFormat, email_format_employee: employeeEmailFormat };
        },
        async save() {
            this.loading = true;
            this.$emit("Saving", this.loading);

            let insert = _.pickBy(this.form, (value, key) => {
                return key !== "__typename" && key !== "id" && key !== "email_formats";
            });

            if (this.orgSettings && this.orgSettings.sftp_host === insert.sftp_host && this.orgSettings.sftp_username === insert.sftp_username && !insert.org_sync_enabled) {
                this.$message.error("Please select a different ASM tenant from your organisation");
                this.loading = false;
                this.$emit("Saving", this.loading);
                return false;
            }

            insert.student_provision_rules = _.map(this.student_rule_object.rules, (rule) => _.pickBy(rule, (value, key) => key !== "__typename"));
            insert.sync_schedules = _.map(this.form.sync_schedules, (schedule) => _.pickBy(schedule, (value, key) => key !== "__typename"));
            insert.student_provision_rule_match = this.student_rule_object.match;

            insert = {
                ...insert,
                sftp_password: this.form.sftp_password ? this.form.sftp_password : null,
                student_active: this.student_rule_object.active,
                employee_active: this.employee_rule_object.active,
            }

            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation SaveSettings($object: SettingsInput!) {
                            SaveSettings(object: $object) {
                                student_active
                                email_format_employee
                                email_format_student
                                student_provision_rule_match
                                employee_org_unit_id
                                custom_email_letters
                                domain
                                employee_active
                                student_provision_rules {
                                    group
                                    operator
                                    value
                                }
                                group_create_misc {
                                    id
                                    name
                                    type
                                }
                                sftp_host
                                sftp_port
                                sftp_username
                                sftp_password
                                user_password
                                password_policy_student
                                password_policy_employee
                                auto_sync_time
                            }
                        }
                    `,
                    variables: {
                        object: insert,
                    },
                })
                .then((r) => {
                    this.loading = false;
                    this.$emit("Saving", false);
                    this.$emit("Saved");
                    this.$message.success("Settings saved");
                })
                .catch((e) => {
                    this.loading = false;
                    this.$emit("Saving", this.loading);
                    this.$message.error("Failed to update settings");
                });
        },
        calcFormatsWithLabels (formatString, domain, extra = "")  {
            // Display data
            const first_name = _.deburr(this.previewUser.first_name),
            mis_id = 'ABC123',
            first_name_letters = first_name ? first_name.split("") : [""],
            last_name = _.deburr(this.previewUser.last_name),
            last_name_letters = last_name ? last_name.split("") : [""],
            number = '2',
            cohort_year = 2015,
            education_details = {
                admission_number: "123456789",
                learner_number: "123456",
                admission_date: moment(),
                year_of_admission: moment().year(),
            };
            let letters = this.custom_email_letters;
            const dot = ".";
            
            return {
                value: formatString,
                label: `${eval(this.removeDotNumbersFromFormat(formatString))
                    .toLowerCase()
                    .replace(/[^\.a-z0-9]/g, "")}@${domain}${extra}`,
                type: 'custom'
            };			
        },
        removeDotNumbersFromFormat(format) {
            return format ? format.replace(/dot\d/g, "dot") : "";
        },
        isOrgSyncDisabled() {
            return this.form && (!this.school.Organisation || !this.form.org_sync_enabled);
        }
    }, 
        
    
    data() {
        return {
            student_rule_object: {
                active: null,
                match: null,
                rules: null,
            },
            employee_rule_object: {
                active: null,
            },
            emailFormatOption: [],
            isPasswordVisible: false,
            passwordPolicies: [
                {
                    label: "Four-digit passcode",
                    value: 4,
                },
                {
                    label: "Six-digit passcode",
                    value: 6,
                },
                {
                    label: "Eight or more numbers and letters password",
                    value: 8,
                },
            ],
            changePasswordOptions: [
                {
                    label: "Yes, I would like to require users to change their passwords at next login",
                    value: 1,
                },
                {
                    label: "No, I would not like to require users to change their passwords at next login",
                    value: 0,
                },
            ],
            originalSettingsValues: null,
            dotsInEmailCount: 0,
            school: {
                name: null
            },
            misLabel: "MIS/SIS",
            fieldNames: {
                course: {
                    "course-id": {
                        label: "Course ID",
                        value: "course_id"
                    },
                    "class-name": {
                        label: "Class name",
                        value: "class_name"
                    },
                    "course-code": {
                        label: "Course code",
                        value: "course_code"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    }
                },
                location: {
                    "edusync-id": {
                        label: "Edusync ID",
                        value: "school_id"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    },
                    "location-name": {
                        label: "Location name",
                        value: "location_name"
                    }
                },
                class: {
                    "class-id": {
                        label: "Class ID",
                        value: "class_id"
                    },
                    "class-name": {
                        label: "Class name",
                        value: "class_name"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "class-mis-id": {
                        label: "Class MIS ID",
                        value: "class_mis_id"
                    },
                    "class-description": {
                        label: "Class description",
                        value: "class_description"
                    },
                    "class-subject-id": {
                        label: "Class subject ID",
                        value: "class_subject_mis_id"
                    },
                    "class-subject-code": {
                        label: "Class subject code",
                        value: "class_subject_code"
                    },
                    "class-subject-name": {
                        label: "Class subject name",
                        value: "class_subject_name"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    }
                },
                roster: {
                    "roster-id": {
                        label: "Roster ID",
                        value: "roster_id"
                    },
                    "class-id": {
                        label: "Class ID",
                        value: "class_id"
                    },
                    "class-code": {
                        label: "Class code",
                        value: "class_code"
                    },
                    "course-id": {
                        label: "Course ID",
                        value: "course_id"
                    },
                    "course-code": {
                        label: "Course code",
                        value: "course_code"
                    },
                    "site-number": {
                        label: "Site number",
                        value: "custom_value"
                    },
                    "person-id": {
                        label: "Person ID",
                        value: "person_id"
                    }
                },
                personIdBase: {
                    "mis-id": {
                        label: "Primary MIS/SIS ID",
                        value: "mis_id"
                    },
                    "mis-secondary-id": {
                        label: "Secondary MIS/SIS ID",
                        value: "mis_secondary_id"
                    },
                    "edusync-id": {
                        label: "Edusync ID",
                        value: "edusync_id"
                    },
                    "forename": {
                        label: "Preferred forename",
                        value: "forename"
                    },
                    "forename-1-letter": {
                        label: "First letter of preferred forename",
                        value: "forename.slice(0, 1)"
                    },
                    "forename-2-letters": {
                        label: "First 2 letters of preferred forename",
                        value: "forename.slice(0, 2)"
                    },
                    "forename-3-letters": {
                        label: "First 3 letters of preferred forename",
                        value: "forename.slice(0, 3)"
                    },
                    "surname": {
                        label: "Preferred surname",
                        value: "surname"
                    },
                    "surname-1-letter": {
                        label: "First letter of preferred surname",
                        value: "surname.slice(0, 1)"
                    },
                    "surname-2-letters": {
                        label: "First 2 letters of preferred surname",
                        value: "surname.slice(0, 2)"
                    },
                    "surname-3-letters": {
                        label: "First 3 letters of preferred surname",
                        value: "surname.slice(0, 3)"
                    },
                    "email": {
                        label: "Email address",
                        value: "email"
                    },
                },
                studentId: {
                    "government-id": {
                        label: "Government ID",
                        value: "government_id"
                    },
                    "admission-number": {
                        label: "Admission number",
                        value: "admission_number"
                    },
                    "learner-number": {
                        label: "Learner number",
                        value: "learner_number"
                    },
                    "upn": {
                        label: "UPN",
                        value: "upn"
                    }
                },
                employeeId: {
                    "teacher-id": {
                        label: "Teacher ID",
                        value: "teacher_id"
                    },
                }
            },
            userEmailOptions: [
                {
                    label: "Primary email",
                    value: "email_primary"
                },
                {
                    label: "Email",
                    value: "email"
                },
                {
                    label: "Work email",
                    value: "email_work"
                },
            ],
            updated: false,
            userEmailAccountCreationOptions: {
                student: [
                    {
                        label: "Ignore students without an email address",
                        value: "ignore_empty"
                    },
                    {
                        label: "Always use a generated email address",
                        value: "use_generated"
                    },
                    {
                        label: "Use a generated email address only for students without an email address",
                        value: "use_generated_if_empty"
                    },
                ],
                employee: [
                    {
                        label: "Ignore staff without an email address",
                        value: "ignore_empty"
                    },
                    {
                        label: "Always use a generated email address",
                        value: "use_generated"
                    },
                    {
                        label: "Use a generated email address only for staff without an email address",
                        value: "use_generated_if_empty"
                    },
                ],
            },
            SISUsernameOptions: [
                {
                    label: "Email local part",
                    value: "email_local_part"
                },
                {
                    label: "MIS/SIS ID",
                    value: "mis_id"
                },
                {
                    label: "Username",
                    value: "username"
                },
                {
                    label: "Username local part",
                    value: "username_local_part"
                },
                {
                    label: "UPN",
                    value: "upn"
                },
            ],
        };
    }
};
</script>
